import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteProviderTokenMutationVariables = Types.Exact<{
  provider: Types.OauthProvider;
  companyId: Types.Scalars['ID']['input'];
}>;


export type DeleteProviderTokenMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteProviderToken: boolean };


export const DeleteProviderTokenDocument = gql`
    mutation DeleteProviderToken($provider: OauthProvider!, $companyId: ID!) {
  deleteProviderToken(provider: $provider, companyId: $companyId)
}
    `;
export type DeleteProviderTokenMutationFn = Apollo.MutationFunction<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>;

/**
 * __useDeleteProviderTokenMutation__
 *
 * To run a mutation, you first call `useDeleteProviderTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderTokenMutation, { data, loading, error }] = useDeleteProviderTokenMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteProviderTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>(DeleteProviderTokenDocument, options);
      }
export type DeleteProviderTokenMutationHookResult = ReturnType<typeof useDeleteProviderTokenMutation>;
export type DeleteProviderTokenMutationResult = Apollo.MutationResult<DeleteProviderTokenMutationPage>;
export type DeleteProviderTokenMutationOptions = Apollo.BaseMutationOptions<DeleteProviderTokenMutationPage, DeleteProviderTokenMutationVariables>;